import { defineMessages } from 'react-intl'

export default defineMessages({
  visitsAndFollowUps: {
    id: 'patientDossier.visitsAndFollowUps',
    defaultMessage: 'Visits & Follow Ups'
  },
  aiSummary: {
    id: 'patientDossier.aiSummary',
    defaultMessage: 'AI Summary'
  },
  prescription: {
    id: 'patientDossier.prescription',
    defaultMessage: 'Prescription'
  },
  clinicalTools: {
    id: 'patientDossier.clinicalTools',
    defaultMessage: 'Clinical tools'
  },
  growthCharts: {
    id: 'patientDossier.growthCharts',
    defaultMessage: 'Growth Charts'
  }
})
